<script>
  import { onMount, afterUpdate } from "svelte";
  import Highcharts from "highcharts";
  import annotations from "highcharts/modules/annotations";
  import IntersectionObserver from "svelte-intersection-observer";

  //intersecitons
  let handlingsRegelIntersect;
  let handlingsRegelElement;
  let oppbyggningIntersect;
  let oppbyggningElement;

  annotations(Highcharts);

  //KILDER:
  // bilpark: https://www.ssb.no/transport-og-reiseliv/landtransport/statistikk/bilparken
  /*
  // Tall for 2022 som kanskje må oppdteres
  let grenseForForbruk2023 = 370.2;
  let budsjettimpuls2022 = -1.2;
  let oljekorrigertUnderskudd2022 = 335100000000;

  let grenseForForbruk2023 = 345;
  //(370.2 er 3% av oljefondets verdi i slutten av 2021
  //Oppdateres fra nasjonalbudsjettet tabell 3.4 Løpende priser 3%
  let budsjettimpuls = -0.6;
  let oljekorrigertUnderskudd = 316800000000;
  */

  let renderFirstGraph = true;

  let revidertOljekorrigertUnderskudd = 372600000000; //oppdateres
  let grenseForForbruk2023 = 372.87; //Må KANSKJe oppdateres
  let oljekorrigertUnderskudd = 316800000000;

  afterUpdate(() => {
    if (renderFirstGraph) {
      const chart = Highcharts.chart("oljebrukHistorikk", {
        chart: {
          type: "column",
          backgroundColor: "rgba(255, 255, 255, 0)",
          style: {
            fontFamily: "E24 text",
          },
        },
        title: {
          text: null,
        },
        annotations: [
          {
            labels: [
              {
                point: { x: 17, y: 407, xAxis: 0, yAxis: 0 }, //., xAxis: 0, yAxis: 0 },
                text: "Handlingsregelen endret \n fra 4% til 3% februar 2017",
              },
            ],
          },
        ],
        plotOptions: {
          column: { groupPadding: 0 },
          line: { marker: { enabled: false } },
        },
        credits: {
          text: "Nasjonalbudsjettet 2023 Tabell 3.4, og handlingsgrense for 2001 - 2017 & 2023 er regnet ut.",
          href: "https://www.regjeringen.no/contentassets/85ceadfcd04b4f23b291223280efc83f/no/pdfs/stm202220230001000dddpdfs.pdf",
        },
        xAxis: [
          {
            categories: [
              //	1998,
              //	1999,
              //	2000,
              2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011,
              2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022,
              2023,
            ],
          },
        ],
        yAxis: {
          title: {
            text: "Strukturelt oljekorrigert underskudd",
          },
          visible: false,
        },
        series: [
          {
            name: "Strukturelt oljekorrigert underskudd",
            type: "column",
            tooltip: {
              valueSuffix: "milliarder kroner",
            },
            data: [
              //	17.454,
              //	12.066,
              //	7.943,
              17.6,
              33.2,
              39.4,
              43.1,
              45.2,
              41.4,
              43,
              52.5,
              91.6,
              98.4,
              90.3,
              104.8,
              118.1,
              141.5,
              164.6,
              195.3,
              207.8,
              205.6,
              231,
              362.8,
              350.4,
              323.7,
              revidertOljekorrigertUnderskudd / 1000000000,
            ],
            color: "#1d1d1d",
          },
          {
            name: "Grense for forbruk satt av handlingsreglen",
            type: "line",
            tooltip: {
              valueSuffix: "milliarder kroner",
            },
            data: [
              15.464,
              24.772,
              24.184,
              33.884,
              40.46,
              55.604,
              71.312,
              80.74,
              91.184,
              105.68,
              123.236,
              132.316,
              152.98,
              201.296,
              257.224,
              298.432,
              300.396,
              254.5,
              247.3,
              302.6,
              327.2,
              370.2,
              grenseForForbruk2023,
            ],
            color: "#7C70FF",
          },
        ],
      });
    } else {
      const vekstOljefondetGraph = Highcharts.chart(
        "vekstOljefondetHistorikk",
        {
          chart: {
            type: "column",
            backgroundColor: "rgba(255, 255, 255, 0)",
            style: {
              fontFamily: "E24 text",
            },
          },
          title: {
            text: null,
          },
          plotOptions: {
            column: { stacking: "normal", groupPadding: 0 },
          },
          credits: {
            text: "Oljefondet",
            href: "https://www.nbim.no/no/oljefondet/markedsverdi/",
          },
          xAxis: {
            categories: [
              "1998",
              "1999",
              "2000",
              "2001",
              "2002",
              "2003",
              "2004",
              "2005",
              "2006",
              "2007",
              "2008",
              "2009",
              "2010",
              "2011",
              "2012",
              "2013",
              "2014",
              "2015",
              "2016",
              "2017",
              "2018",
              "2019",
              "2020",
              "2021",
              "2022",
            ],
          },
          yAxis: {
            title: {
              text: "Oljekorrigert overskudd",
            },
          },

          yAxis: {
            visible: false,
          },
          series: [
            {
              name: "Kronekurs",
              data: [
                18.33, 21.24, 29.52, 14.09, -86.56, -45.74, -94.9, -59.23,
                -87.05, -240.55, 265.61, -152, -160.5, -111.29, -330.86, -39.43,
                662.83, 1330.97, 1024.87, 1039.6, 1263.21, 1389.86, 1447.81,
                1423.22, 2065.07,
              ],
              color: "#7C70FF",
            },
            {
              name: "Avkastning",
              data: [
                12.2, 35.44, 41.33, 32.74, 3.32, 94.9, 176.98, 303.67, 427.83,
                502.64, -130.5, 482.31, 746.18, 659.94, 1107.36, 1798.89,
                2342.53, 2676.31, 3122.98, 4150.74, 3665.55, 5357.68, 6427.39,
                8007.25, 6370.07,
              ],
              color: "#4326C8",
            },
            {
              name: "Tilførsel fra staten",
              data: [
                141.31, 165.73, 315.6, 566.86, 692.24, 796.15, 934.32, 1154.61,
                1442.91, 1756.56, 2140.32, 2309.73, 2491.73, 2762.93, 3039.26,
                3278.27, 3425.38, 3467.88, 3362.65, 3298.11, 3327.19, 3340.54,
                3038.56, 2909.08, 3993.92,
              ],
              color: "#1D1D1D",
            },
          ],
        }
      );
    }
  });
</script>

<main>
  <div class="graph-section">
    <IntersectionObserver
      once
      element={handlingsRegelElement}
      bind:intersecting={handlingsRegelIntersect}
    >
      <div
        bind:this={handlingsRegelElement}
        class="chartContainer"
        class:handlingsRegelIntersect
      >
        <div id="oljebrukHistorikk" />
      </div>
    </IntersectionObserver>
  </div>
  <div class="graph-section">
    <IntersectionObserver
      once
      element={oppbyggningElement}
      bind:intersecting={oppbyggningIntersect}
    >
      <div
        bind:this={oppbyggningElement}
        class="chartContainer"
        class:oppbyggningIntersect
      >
        <div id="vekstOljefondetHistorikk" />
      </div>
    </IntersectionObserver>
  </div>
</main>

<style>
  main {
    text-align: center;
    font-family: "E24 text";
    margin: 0 auto;
  }

  .graph-section {
    background-color: #fff8fb;
  }

  .graphText {
    max-width: 680px;
    text-align: center;
    margin: 0 auto;
    font-size: 1.5em;
    padding: 0 10px;
  }

  .chartContainer {
    max-width: 600px;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 0 auto;
    opacity: 0;
    -webkit-transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    transition: opacity 0.5s ease-in-out;
  }
  .handlingsRegelIntersect,
  .oppbyggningIntersect {
    opacity: 1;
  }
</style>
